import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { TranslationService } from '../../translations';

@Component({
    selector: 'inactive-feature-tooltip-content',
    styles: ['.inactiveTooltip {min-width: 180px; padding: 5px;}'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="layoutCenteredColumn inactiveTooltip">
            <abstract-icon
                class="color-person"
                [iconType]="IconType.TransparentLock"
                [iconSize]="IconSize.Big"
            ></abstract-icon>
            <div class="mediumText boldText">
                {{ TR.key('pizza.team-activities-inactive-tooltip.title') }}
            </div>
            <div class="smallText">
                {{ TR.key('pizza.team-activities-inactive-tooltip.body') }}
            </div>
        </div>
    `,
    standalone: false
})
export class InactiveFeatureTooltipContentComponent {
    IconSize = IconSize;
    IconType = IconType;

    constructor(public TR: TranslationService) {}
}
